export const ALLOWED_RECORDING_FILTER_KEYS = [
  'uploaded_by',
  'organization_name',
  'shared_by',
  'created_by',
  'sdk_prod_type',
  'sdk_prod_beam_spacing',
  'sdk_prod_resolution',
  'sdk_prod_hw_rev',
  'sdk_prod_generation',
  'sdk_prod_sn',
  'sdk_fw_version_core',
  'sdk_lidar_mode',
  'data_category',
  'tags',
  // Legacy / URL-compatible aliases still exercised by query code and tests.
  'sensor',
  'asset',
] as const;

export const isAllowedRecordingFilterKey = (key: string): boolean =>
  ALLOWED_RECORDING_FILTER_KEYS.includes(
    key as (typeof ALLOWED_RECORDING_FILTER_KEYS)[number]
  );

export const sanitizeRecordingFilters = (
  filters: Record<string, string[]>
): Record<string, string[]> =>
  Object.fromEntries(
    Object.entries(filters).filter(([key]) => isAllowedRecordingFilterKey(key))
  );
